import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { motion, useScroll, useSpring, useMotionValue } from "framer-motion";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import api from "@/lib/api";

export default function Layout() {
  const [profile, setProfile] = useState(null);
  
  // High-performance cursor trailing using motion values (prevents React re-renders)
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);
  
  // Custom spring configurations for organic organic damping trail
  const springConfig = { stiffness: 60, damping: 20, mass: 0.2 };
  const glowX = useSpring(mouseX, springConfig);
  const glowY = useSpring(mouseY, springConfig);

  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 100, damping: 30, restDelta: 0.001 });

  useEffect(() => {
    api.get("/profile").then((r) => setProfile(r.data)).catch(() => {});

    const handleMouseMove = (e) => {
      mouseX.set(e.clientX);
      mouseY.set(e.clientY);
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, [mouseX, mouseY]);

  return (
    <div className="App relative min-h-screen">
      {/* Scroll Progress Bar */}
      <motion.div className="fixed top-0 left-0 right-0 h-[3px] bg-primary origin-left z-50" style={{ scaleX }} />

      {/* Mouse Glow Background Overlay (direct transform updates, zero transitions) */}
      <motion.div
        className="pointer-events-none fixed -translate-x-1/2 -translate-y-1/2 rounded-full w-[380px] h-[380px] bg-primary/5 dark:bg-primary/5 blur-[90px] z-30"
        style={{ x: glowX, y: glowY }}
      />

      <div className="pointer-events-none fixed inset-0 -z-10 mesh-light dark:mesh-dark opacity-70" />
      <Navbar />
      <main className="pt-28">
        <Outlet context={{ profile }} />
      </main>
      <Footer profile={profile} />
    </div>
  );
}
